module.exports = __webpack_public_path__ + "img/add_gray.185a3271.svg";